<template>
  <svg viewBox="0 0 64 64">
    <path
      d="M32,23.2c-3.7,0-6.8,3.1-6.8,6.9c0,2.6,0.7,3.6,2,4.8l0.5,0.5c0.8,0.7,1,1,1,2v1c0,0.5,0.3,1,0.7,1.3v0.7
                c0,1.2,1.1,2.2,2.6,2.2c1.5,0,2.6-1,2.6-2.2v-0.7c0.4-0.3,0.7-0.7,0.7-1.3v-1c0-1,0.2-1.2,1-2l0.5-0.5c1.2-1.2,2-2.2,2-4.8
                C38.8,26.3,35.8,23.2,32,23.2z M33,40.3c0,0.2-0.4,0.6-1,0.6c-0.6,0-1-0.3-1-0.6v-0.4h2V40.3z M33.7,38.3l-3.1,0.1
                c-0.1,0-0.2-0.1-0.3-0.1v-0.4h3.4V38.3z M35.7,33.8l-0.5,0.5c-0.6,0.6-1.2,1.1-1.4,2.1h-3.6c-0.2-1-0.8-1.5-1.4-2.1l-0.5-0.4
                c-1-1-1.5-1.5-1.5-3.7c0-2.9,2.3-5.2,5.2-5.2c2.8,0,5.2,2.3,5.2,5.2C37.2,32.3,36.7,32.8,35.7,33.8z"
    />
    <path
      d="M47.2,44.3h-1.1v0.8h0v-0.8h0V17.4H17.9v26.9v0.8h0v-0.8h-1.1c-0.4,0-0.8,0.4-0.8,0.8c0,0.5,0.4,0.8,0.8,0.8h30.4
                c0.4,0,0.8-0.4,0.8-0.8C48,44.7,47.7,44.3,47.2,44.3z M19.5,44.3V19h4.7l0.2-0.9l1.6,0.3l-1.6-0.3L24.3,19l-4.1,25.3H19.5
                L19.5,44.3z M21.8,44.3L25.9,19v0h11.6l4.1,25.3H21.8z M44.5,45.1v-0.8h-1.2L39.2,19h5.3v25.3h0L44.5,45.1L44.5,45.1z"
    />
    <path
      d="M32,8C18.5,8,7.4,19.2,7.4,32.9s11.1,25,24.6,25c13.6,0,24.6-11.2,24.6-25S45.6,8,32,8z M32,56.3c-12.7,0-23-10.5-23-23.3
                S19.3,9.6,32,9.6s23,10.5,23,23.3S44.7,56.3,32,56.3z"
    />
    <path
      d="M32,6.7c0.4,0,0.8-0.4,0.8-0.8V0.8C32.8,0.4,32.5,0,32,0c-0.4,0-0.8,0.4-0.8,0.8v5.1C31.2,6.4,31.6,6.7,32,6.7z"
    />
    <path
      d="M14.3,12.8c0.2,0.2,0.4,0.3,0.6,0.3c0.2,0,0.4-0.1,0.5-0.2c0.3-0.3,0.4-0.8,0.1-1.1l-3.2-3.9c-0.3-0.3-0.8-0.4-1.1-0.1
                C10.8,8,10.8,8.5,11,8.9L14.3,12.8z"
    />
    <path
      d="M5.8,29.1c0.4,0,0.7-0.3,0.8-0.7c0.1-0.4-0.2-0.9-0.7-0.9l-5-0.9c-0.4-0.1-0.9,0.2-0.9,0.7c-0.1,0.4,0.2,0.9,0.7,0.9
                l4.9,0.9C5.7,29.1,5.7,29.1,5.8,29.1z"
    />
    <path
      d="M8.5,45.8l-4.4,2.6c-0.4,0.2-0.5,0.7-0.3,1.1c0.1,0.3,0.4,0.4,0.7,0.4c0.1,0,0.3,0,0.4-0.1l4.4-2.6
                c0.4-0.2,0.5-0.7,0.3-1.1C9.4,45.7,8.9,45.5,8.5,45.8z"
    />
    <path
      d="M23.2,57.6c-0.4-0.2-0.9,0.1-1,0.5l-1.7,4.8c-0.2,0.4,0.1,0.9,0.5,1c0.1,0,0.2,0.1,0.3,0.1c0.3,0,0.6-0.2,0.8-0.5l1.7-4.8
                C23.8,58.2,23.6,57.7,23.2,57.6z"
    />
    <path
      d="M40.9,57.6c-0.4,0.2-0.6,0.6-0.5,1l1.7,4.8c0.1,0.3,0.4,0.5,0.8,0.5c0.1,0,0.2,0,0.3-0.1c0.4-0.2,0.6-0.6,0.5-1l-1.7-4.8
                C41.8,57.7,41.3,57.4,40.9,57.6z"
    />
    <path
      d="M55.6,45.8c-0.4-0.2-0.9-0.1-1.1,0.3c-0.2,0.4-0.1,0.9,0.3,1.1l4.4,2.5c0.1,0.1,0.3,0.1,0.4,0.1c0.3,0,0.5-0.1,0.7-0.4
                c0.2-0.4,0.1-0.9-0.3-1.1L55.6,45.8z"
    />
    <path
      d="M63.1,26.6l-4.9,0.9c-0.4,0.1-0.7,0.5-0.7,0.9c0.1,0.4,0.4,0.7,0.8,0.7c0,0,0.1,0,0.1,0l4.9-0.9c0.4-0.1,0.7-0.5,0.7-0.9
                C64,26.8,63.6,26.5,63.1,26.6z"
    />
    <path
      d="M49.2,13c0.2,0,0.5-0.1,0.6-0.3L53,8.9c0.3-0.3,0.2-0.9-0.1-1.1c-0.3-0.3-0.8-0.2-1.1,0.1l-3.2,3.9
                c-0.3,0.3-0.2,0.9,0.1,1.1C48.8,13,49,13,49.2,13z"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconMeerComfort extends Vue {}
</script>
